var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunAvatarGroupElement_instances, _DuoyunAvatarGroupElement_max_get, _DuoyunAvatarGroupElement_renderAvatar;
var DuoyunAvatarElement_1;
import { adoptedStyle, customElement, attribute, property, boolattribute, numattribute, part, } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { theme } from '../lib/theme';
import { getStatusColor } from './status-light';
import './tooltip';
const style = createCSSSheet(css `
  :host {
    cursor: default;
    display: inline-block;
    position: relative;
    width: 2.4em;
    aspect-ratio: 1;
    --offset: 14.645%;
    --radius: 100em;
    --size: 0.6em;
    --mask: calc(var(--size) / 2 + 0.07em);
  }
  :host([square]) {
    --offset: 0%;
    --radius: ${theme.smallRound};
  }
  :host([size='small']) {
    width: 1.6em;
  }
  :host([size='large']) {
    width: 3.8em;
  }
  .content {
    width: 100%;
    aspect-ratio: 1;
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--radius);
    object-fit: cover;
    background: ${theme.hoverBackgroundColor};
    box-sizing: border-box;
  }
  :host([status]:not([status=''])) .content {
    --m: radial-gradient(
      circle at calc(100% - var(--offset)) var(--offset),
      #0000 var(--mask),
      #fff calc(var(--mask) + 0.5px)
    );
    -webkit-mask-image: var(--m);
    mask-image: var(--m);
  }
  .status {
    position: absolute;
    top: var(--offset);
    right: var(--offset);
    width: var(--size);
    border-radius: 10em;
    aspect-ratio: 1;
    transform: translate(50%, -50%);
    background-color: var(--status);
  }
`);
/**
 * @customElement dy-avatar
 * @attr src
 * @attr alt
 * @attr status
 * @attr background
 * @attr tooltip
 * @attr size
 * @attr square
 */
let DuoyunAvatarElement = DuoyunAvatarElement_1 = class DuoyunAvatarElement extends GemElement {
    constructor() {
        super(...arguments);
        this.render = () => {
            const status = getStatusColor(this.status);
            return html `
      <style>
        :host {
          --status: ${status || 'inherit'};
        }
      </style>
      <dy-tooltip .content=${this.tooltip}>
        <div class="content">
          ${this.src &&
                html `
            <img
              class="content"
              alt=${this.alt || this.src}
              src=${this.src}
              part=${DuoyunAvatarElement_1.avatar}
              crossorigin=${this.crossorigin}
            />
          `}
          <slot></slot>
        </div>
      </dy-tooltip>
      ${this.status ? html `<div class="status"></div>` : ''}
    `;
        };
    }
};
__decorate([
    attribute
], DuoyunAvatarElement.prototype, "src", void 0);
__decorate([
    attribute
], DuoyunAvatarElement.prototype, "alt", void 0);
__decorate([
    attribute
], DuoyunAvatarElement.prototype, "status", void 0);
__decorate([
    attribute
], DuoyunAvatarElement.prototype, "tooltip", void 0);
__decorate([
    attribute
], DuoyunAvatarElement.prototype, "size", void 0);
__decorate([
    attribute
], DuoyunAvatarElement.prototype, "crossorigin", void 0);
__decorate([
    boolattribute
], DuoyunAvatarElement.prototype, "square", void 0);
__decorate([
    part
], DuoyunAvatarElement, "avatar", void 0);
DuoyunAvatarElement = DuoyunAvatarElement_1 = __decorate([
    customElement('dy-avatar'),
    adoptedStyle(style)
], DuoyunAvatarElement);
export { DuoyunAvatarElement };
const groupStyle = createCSSSheet(css `
  :host {
    display: flex;
  }
  .item:not(:first-child) {
    margin-inline-start: -0.4em;
  }
  .item:not(:last-child) {
    --m: radial-gradient(circle at calc(150% - 0.4em) center, #0000 37%, #fff calc(37% + 0.5px));
    -webkit-mask-image: var(--m);
    mask-image: var(--m);
  }
`);
/**
 * @customElement dy-avatar-group
 */
let DuoyunAvatarGroupElement = class DuoyunAvatarGroupElement extends GemElement {
    constructor() {
        super();
        _DuoyunAvatarGroupElement_instances.add(this);
        _DuoyunAvatarGroupElement_renderAvatar.set(this, ({ src = '', tooltip = '', alt = '', status, onClick }) => {
            return html `
      <dy-avatar
        exportparts=${DuoyunAvatarElement.avatar}
        class="item"
        .src=${src}
        .tooltip=${tooltip}
        .alt=${alt}
        .status=${status}
        @click=${onClick}
      ></dy-avatar>
    `;
        });
        this.render = () => {
            if (!this.data)
                return html ``;
            const rest = this.data.slice(__classPrivateFieldGet(this, _DuoyunAvatarGroupElement_instances, "a", _DuoyunAvatarGroupElement_max_get));
            return html `
      ${this.data.slice(0, __classPrivateFieldGet(this, _DuoyunAvatarGroupElement_instances, "a", _DuoyunAvatarGroupElement_max_get)).map((avatar) => __classPrivateFieldGet(this, _DuoyunAvatarGroupElement_renderAvatar, "f").call(this, avatar))}
      ${rest.length
                ? html `
            <dy-avatar exportparts=${DuoyunAvatarElement.avatar} class="item" .tooltip=${rest.map((e) => e.alt).join()}>
              +${rest.length}
            </dy-avatar>
          `
                : ''}
    `;
        };
        this.internals.role = 'group';
    }
};
_DuoyunAvatarGroupElement_renderAvatar = new WeakMap(), _DuoyunAvatarGroupElement_instances = new WeakSet(), _DuoyunAvatarGroupElement_max_get = function _DuoyunAvatarGroupElement_max_get() {
    var _a;
    return this.max || ((_a = this.data) === null || _a === void 0 ? void 0 : _a.length) || 0;
};
__decorate([
    numattribute
], DuoyunAvatarGroupElement.prototype, "max", void 0);
__decorate([
    property
], DuoyunAvatarGroupElement.prototype, "data", void 0);
DuoyunAvatarGroupElement = __decorate([
    customElement('dy-avatar-group'),
    adoptedStyle(groupStyle)
], DuoyunAvatarGroupElement);
export { DuoyunAvatarGroupElement };
//# sourceMappingURL=avatar.js.map